import VueRouter from 'vue-router';
import Vue from 'vue';
import outlet from './route-components/outlet';
import myaccount from './route-components/myaccount';
import device from './route-components/device';
import supplier from './route-components/franchise-inventory/supplier';
import stockCheck from './route-components/franchise-inventory/stock-check';
import stockReceive from './route-components/franchise-inventory/stock-receive';
import stockReturn from './route-components/franchise-inventory/stock-return';

// inventory fnb router
import fnbStockReceive from './route-components/inventory-fnb/stock-receive';
import fnbStockReturn from './route-components/inventory-fnb/stock-return';
import fnbStockCheck from './route-components/inventory-fnb/stock-check';
import fnbSupplier from './route-components/inventory-fnb/supplier';

const routeComponents = {
    outlet,
    myaccount,
    device,
    supplier,
    stockCheck,
    stockReceive,
    stockReturn,
    fnbStockReceive,
    fnbStockReturn,
    fnbStockCheck,
    fnbSupplier,
};

module.exports = function(routeKey) {
    Vue.use(VueRouter);

    const routes = routeComponents[routeKey];
    const router = new VueRouter({
        routes,
        linkActiveClass: 'active',
    });

    return router;
};



// WEBPACK FOOTER //
// ./resources/assets/js/router/index.js